import { FontSizes, FontWeights, HighContrastSelectorBlack } from '@fluentui/react/lib/Styling';
export var getStyles = function (props) {
    var _a;
    var theme = props.theme;
    return {
        root: {},
        insideDonutString: {
            fontSize: FontSizes.xLargePlus,
            fontWeight: FontWeights.semibold,
            fill: theme.semanticColors.bodyText,
            selectors: (_a = {},
                _a[HighContrastSelectorBlack] = {
                    fill: 'rgb(179, 179, 179)',
                },
                _a),
        },
    };
};
//# sourceMappingURL=Pie.styles.js.map